import React, { useState, useEffect } from 'react';

function CustomSlider({
  label,
  initialValue = 25,
  onValueChange,
  minRange = 0,
  maxRange = 100,
  showPercentage = true,
}) {
  const [value, setValue] = useState(Number(initialValue));

  useEffect(() => {
    setValue(Number(initialValue));
  }, [initialValue]);

  const handleSliderChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setValue(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  const getPercentage = () => {
    const min = parseFloat(minRange);
    const max = parseFloat(maxRange);
    return ((value - min) / (max - min)) * 100;
  };

  const percentage = getPercentage();

  return (
    <div style={{ width: '100%' }}>
      {label && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '0.5rem',
          }}
        >
          <label
            style={{
              fontSize: '0.875rem',
              fontWeight: '500',
              color: '#374151',
            }}
          >
            {label}
          </label>
          <span
            style={{
              fontSize: '0.875rem',
              fontWeight: '600',
              color: 'var(--primary-400)',
            }}
          >
            {showPercentage ? `${Math.round(percentage)}%` : value.toFixed(2)}
          </span>
        </div>
      )}

      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '8px',
          backgroundColor: '#e2e8f0',
          borderRadius: '9999px',
          marginBottom: label ? '0' : '1rem',
        }}
      >
        {/* Blue progress track */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: `${percentage}%`,
            backgroundColor: 'var(--primary-400)',
            borderRadius: '9999px',
            transition: 'width 0.2s ease',
          }}
        />

        {/* Slider thumb */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: `${percentage}%`,
            transform: 'translate(-50%, -50%)',
            width: '20px',
            height: '20px',
            backgroundColor: 'white',
            border: '3px solid #3d9f5f',
            borderRadius: '50%',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'left 0.2s ease',
          }}
        />

        {/* Hidden range input */}
        <input
          type="range"
          min={minRange}
          max={maxRange}
          step="any"
          value={value}
          onChange={handleSliderChange}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
          }}
        />
      </div>

      {!label && (
        <div
          style={{
            textAlign: 'center',
            fontSize: '0.875rem',
            color: 'var(--primary-400)',
            fontWeight: '500',
          }}
        >
          Value: {value.toFixed(2)}{showPercentage ? '%' : ''}
        </div>
      )}
    </div>
  );
}

export default CustomSlider;
